export const DISPATCH_BOARD_LIST_REQUEST = "DISPATCH_BOARD_LIST_REQUEST";
export const DISPATCH_BOARD_LIST_SUCCESS = "DISPATCH_BOARD_LIST_SUCCESS";
export const DISPATCH_BOARD_LIST_FAIL    = "DISPATCH_BOARD_LIST_FAIL";

export const DISPATCH_BOARD_DATA_REQUEST = "DISPATCH_BOARD_DATA_REQUEST";
export const DISPATCH_BOARD_DATA_SUCCESS = "DISPATCH_BOARD_DATA_SUCCESS";
export const DISPATCH_BOARD_DATA_FAIL    = "DISPATCH_BOARD_DATA_FAIL";

export const DISPATCH_BOARD_CREATE_REQUEST = "DISPATCH_BOARD_CREATE_REQUEST";
export const DISPATCH_BOARD_CREATE_SUCCESS = "DISPATCH_BOARD_CREATE_SUCCESS";
export const DISPATCH_BOARD_CREATE_FAIL    = "DISPATCH_BOARD_CREATE_FAIL";

export const DISPATCH_BOARD_UPDATE_REQUEST = "DISPATCH_BOARD_UPDATE_REQUEST";
export const DISPATCH_BOARD_UPDATE_SUCCESS = "DISPATCH_BOARD_UPDATE_SUCCESS";
export const DISPATCH_BOARD_UPDATE_FAIL    = "DISPATCH_BOARD_UPDATE_FAIL";

export const DISPATCH_BOARD_DELETE_REQUEST = "DISPATCH_BOARD_DELETE_REQUEST";
export const DISPATCH_BOARD_DELETE_SUCCESS = "DISPATCH_BOARD_DELETE_SUCCESS";
export const DISPATCH_BOARD_DELETE_FAIL    = "DISPATCH_BOARD_DELETE_FAIL";
